import { z } from 'zod';

export const phoneSchema = z.string().regex(/^\(\d{2}\) (\d{5}|\d{4})-(\d{4})/);
